import React from 'react';
import {Link,useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { useSelector, useDispatch} from 'react-redux';
import { setLogout } from '../../reducers/User/action';


function Navigation() {
  const navigation = useNavigate();
  const dispatch=useDispatch();
  const doLogout = ()=>{
    dispatch(setLogout());
    navigation("/Login");
  }

  let loggedUser = useSelector(store => store.user['user'])
  return (
    <>  
    <Navbar expand='md' >
      {/* <Navbar.Brand href={process.env.PUBLIC_URL+'/home'}><img src={process.env.PUBLIC_URL+'/assets/logo.png'}/></Navbar.Brand> */}
      <Link to='/home' style={{marginLeft: "5px"}}><img src={process.env.PUBLIC_URL+'/assets/logo.png'}/></Link>
        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-md`} />
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-md`}
          aria-labelledby={`offcanvasNavbarLabel-expand-md`}
          placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`}>
             
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav  className=" flex-grow-1 pe-3 center">
            <span>Welcome {loggedUser ? loggedUser.name : ''} - </span><Link to='/home' style={{marginLeft: "5px"}}>Admin</Link> 
              {/* <Link to='/'>Edit Account Info</Link>
              <Link to='/'>Change Password</Link> */}
             <a href="javascript:void(0);" onClick={()=> doLogout()}>Logout</a>
            </Nav> 
          </Offcanvas.Body>
        </Navbar.Offcanvas>
    </Navbar>
  
</>
  );
}

export default Navigation;